module.exports = __webpack_public_path__ + "img/residencia.b28bb8e7.png";